import { BadgeStyled } from '@procurify/ui'
import styled from 'styled-components'

export const CatalogItemIndicatorStyled = styled.i`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  display: inline-block;

  ${BadgeStyled} {
    border-radius: ${(props) =>
      props.theme.box.borderRadius(props.theme.typography.htmlFontSize)};
  }
`
